import { z } from 'zod';

const browserEnvSchema = z
  .object({
    VITE_APP_ENV: z.enum(['development', 'test', 'preview', 'production']),
    VITE_BUILD_ID: z.string().min(1).max(100),
    VITE_SUPABASE_URL: z.url().refine(
      // Loopback (local Supabase CLI, `supabase start`) never leaves the
      // machine, so plaintext HTTP there carries none of the real risk
      // this rule exists to prevent -- every other host must still be
      // HTTPS.
      (value) =>
        value.startsWith('https://') ||
        /^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?(\/|$)/.test(value),
      'Supabase URL must use HTTPS (loopback excepted for local development)',
    ),
    VITE_SUPABASE_PUBLIC_KEY: z
      .string()
      .min(20)
      .refine(
        (value) => !/service[_-]?role/i.test(value),
        'Service-role credentials are forbidden in browser configuration',
      ),
  })
  .strict();

export type BrowserEnv = z.infer<typeof browserEnvSchema>;
export function parseBrowserEnv(input: unknown): BrowserEnv {
  return browserEnvSchema.parse(input);
}
export function readBrowserEnv(): BrowserEnv {
  return parseBrowserEnv({
    VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
    VITE_BUILD_ID: import.meta.env.VITE_BUILD_ID,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLIC_KEY: import.meta.env.VITE_SUPABASE_PUBLIC_KEY,
  });
}
